import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import styled from 'styled-components';
import { useUI } from '../../context/UIContext';

const AppContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: var(--content-bg);
  position: relative; /* Needed for absolute positioning of sidebar on mobile */
`;

// Renamed for clarity, now handles mobile width correctly
const ContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease;

  @media (min-width: 992px) {
    margin-left: ${props => props.isCollapsed ? '0' : '0'};
  }
`;

const SidebarBackdrop = styled.div`
    /* This is the styled component version of our CSS class */
`;
const MainLayout = ({ children }) => {
  const { isSidebarCollapsed, toggleSidebar, isMobile } = useUI();

  return (
    <AppContainer>
      <Sidebar />
       {/* The backdrop is only rendered on mobile and is active when the sidebar is open */}
      {isMobile && !isSidebarCollapsed && (
        <div 
          className="sidebar-backdrop active"
          onClick={toggleSidebar} // Clicking the backdrop closes the sidebar
        />
      )}
      
      <ContentWrapper isCollapsed={isSidebarCollapsed} className="main-content-wrapper">
        <Header />
        <main className="main-content">
          {children}
        </main>
      </ContentWrapper>
    </AppContainer>
  );
};

export default MainLayout;